export const isValidPowerpointSlidesURL = (rawUrl: string) => {
  try {
    const url = new URL(rawUrl);
    const isValidSharepointUrl =
      url.origin.endsWith('sharepoint.com') && url.search.includes('embedview');
    const isValidOneDriveUrl =
      url.origin === 'https://onedrive.live.com' &&
      url.pathname.includes('/embed');

    return isValidSharepointUrl || isValidOneDriveUrl;
  } catch {
    return false;
  }
};

export const buildPowerpointSlidesURL = (
  rawUrl = '',
  startingSlideNumber = 1,
) => {
  if (!rawUrl) return '';

  return `${rawUrl}${
    !/&wdSlideIndex=/i.test(rawUrl)
      ? '&wdSlideIndex=' + startingSlideNumber
      : ''
  }`;
};

export const getPowerpointUrlFromIframe = (url: string) => {
  if (isValidPowerpointSlidesURL(url)) return decodeAmpersands(url);

  const match = url.match(/(?<=src=").*?(?=[\*"])/);
  const src = match ? match[0] : '';

  return decodeAmpersands(src);
};

function decodeAmpersands(url: string) {
  return url.replaceAll('&amp;', '&');
}
